import { Component, HostListener, OnInit } from '@angular/core';
import { AuthService } from '@app/common/services/auth.service';
import { SettingsService } from "@app/ps/services/settings.service";
import { ColorUtils } from "@app/common/utils/color.utils";

interface PriorityCategory {
  name: string;
  visible: boolean;
  color: any;
}

@Component({
  selector: 'priority-permanent-occupations',
  templateUrl: './priorities-permanent-occupations.component.html',
  styleUrls: ['./priorities-permanent-occupations.component.scss'],
})
export class PrioritiesPermanentOccupationsComponent implements OnInit {

  private readonly DEFAULT_COLORS = ["#cccccc", "#1a427b", "#3d6fb3","#6ea8e6", "#a9d6f8", "#e2f0fe"]
    .map((color: string) => ColorUtils.hexToRGBA(color));

  loading = true;
  readonly maxCategories = this.DEFAULT_COLORS.length - 1;
  occupationsPriority = {
    enabled: false,
    categories: [{ name: 'Bez priority', visible: false, color: this.DEFAULT_COLORS[0] }],
  };
  colorPickerIndex: number | null = null;
  settings: any;

  projectId = this.authService.getActualProject().id;


  constructor(
    private authService: AuthService,
    private settingsService: SettingsService,
  ) {
    this.save = this.save.bind(this);
    this.addCategory = this.addCategory.bind(this);
  }

  async ngOnInit() {
      await this.loadSettings();
      if (this.settings.occupationsPriority) {
          this.occupationsPriority = this.settings.occupationsPriority;
      }
      this.loading = false;
  }

  async loadSettings() {
      return this.settingsService.loadSettings(this.projectId)
        .then(s => {
          this.settings = this.settingsService.getSettings();
        });
  }

  addCategory() {
    if (this.occupationsPriority.categories.length > this.maxCategories) {
      return;
    }
    const colorIndex = this.occupationsPriority.categories.length % this.DEFAULT_COLORS.length;
    this.occupationsPriority.categories.push({
      name: `Priorita ${this.occupationsPriority.categories.length}`,
      visible: false,
      color: this.DEFAULT_COLORS[colorIndex],
    });
  }

  removeCategory(index: number) {
    if (this.occupationsPriority.categories.length <= 1) {
      return;
    }

    this.occupationsPriority.categories.splice(index, 1);
    if (this.colorPickerIndex === index) {
      this.colorPickerIndex = null;
    }
  }

  toggleColorPicker(index: number) {
    this.colorPickerIndex = this.colorPickerIndex === index ? null : index;
  }

  toRgbaString(obj: any): string {
    const { r, g, b, a } = obj;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  onCategoryColorChange(index: number, event: any) {
    this.occupationsPriority.categories[index].color = event.color.rgb;
  }

  save() {
      this.settings.occupationsPriority = this.occupationsPriority;
      return this.settingsService.settingsUpload(this.projectId, this.settings);
  }

  isNameUnique(): boolean {
    const names = this.occupationsPriority.categories
      .map(c => c.name.trim().toLowerCase());
    return new Set(names).size === names.length;
  }

  isNameFilled(): boolean {
    return this.occupationsPriority.categories.every(c => c.name.trim().length > 0);
  }

  isValid(): boolean {
    return this.isNameFilled() && this.isNameUnique();
  }

  @HostListener('document:click', ['$event.target'])
  clickout(target: HTMLElement) {
    if (this.colorPickerIndex === null || !target) {
      return;
    }
    if (target.closest('.priority-color-swatch') || target.closest('.priority-color-picker')) {
      return;
    }
    this.colorPickerIndex = null;
  }
}
